import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import api from '../api/client';

export default function NotificationsPage() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { data: notifs = [] } = useQuery({
    queryKey: ['notifications'],
    queryFn: () => api.get('/notifications').then(r => r.data),
  });

  const markAllRead = useMutation({
    mutationFn: () => api.post('/notifications/read-all'),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['notifications'] }); qc.invalidateQueries({ queryKey: ['unread-count'] }); },
  });

  const markRead = useMutation({
    mutationFn: (id) => api.post(`/notifications/${id}/read`),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ['notifications'] }); qc.invalidateQueries({ queryKey: ['unread-count'] }); },
  });

  return (
    <div style={{ maxWidth: 700 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h1 style={{ fontFamily: 'var(--font-serif)', fontSize: 32, fontWeight: 400 }}>Notifications</h1>
        {notifs.some(n => !n.lu) && (
          <button className="btn btn-outline btn-sm notif-mark-all" onClick={() => markAllRead.mutate()}>Mark all as read</button>
        )}
      </div>
      {notifs.length === 0 && <p style={{ color: 'var(--color-text-muted)' }}>No notifications.</p>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {notifs.map(n => (
          <div
            key={n.id}
            style={{
              background: n.lu ? 'white' : '#FFFDF6',
              border: `1px solid ${n.lu ? 'var(--color-border)' : 'var(--color-gold)'}`,
              borderRadius: 'var(--radius)', padding: 16, cursor: n.lu ? 'default' : 'pointer',
              display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12
            }}
            onClick={() => {
              if (!n.lu) markRead.mutate(n.id);
              if (n.product_id) navigate(`/products/${n.product_id}`);
            }}
          >
            {n.image_url && (
              <img src={n.image_url} alt="" style={{ width: 56, height: 56, borderRadius: 4, objectFit: 'contain', background: '#f5f4f0', flexShrink: 0 }} />
            )}
            <div style={{ flex: 1 }}>
              <div style={{ fontWeight: 500, marginBottom: 4 }}>{n.titre}</div>
              <div style={{ fontSize: 13, color: 'var(--color-text-muted)', lineHeight: 1.5 }}>{n.message}</div>
              <div style={{ fontSize: 11, color: 'var(--color-text-muted)', marginTop: 8 }}>
                {new Date(n.created_at).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}
              </div>
            </div>
            {!n.lu && <div style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--color-gold)', flexShrink: 0, marginTop: 4 }} />}
          </div>
        ))}
      </div>
    </div>
  );
}
